module.exports = __webpack_public_path__ + "img/course_0011.3d9eeaa.png";